import {createContext, useContext, useState, useMemo} from 'react';

export const PurchaseContext = createContext<IPurchaseContext>({
  purchaseValue: undefined,
  stepTwoInfo: () => null,
  resetForm: () => null,
});
type TPurchaseProviderProps = {
  children: React.ReactNode;
};

export const PurchaseProvider = ({children}: TPurchaseProviderProps) => {
  const [purchaseValue, setPurchaseValue] = useState<
    IPurchaseValue | undefined
  >();

  const stepTwoInfo = (values: IPurchaseValue) => {
    setPurchaseValue(prev => ({
      ...prev,
      ...values,
    }));
  };
  const resetForm = () => {
    setPurchaseValue(undefined);
  };

  const value = useMemo(
    () => ({
      purchaseValue,
      stepTwoInfo,
      resetForm,
    }),
    [purchaseValue],
  );
  return (
    <PurchaseContext.Provider value={value}>
      {children}
    </PurchaseContext.Provider>
  );
};
export const usePurchase = () => {
  return useContext(PurchaseContext);
};
